import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { removeCatalogUEROtherCostTemplates } from '../catalogUerOtherCostTemplatesQueries';

const requestId = 'useRemoveOtherCostTemplates';

export const useRemoveOtherCostTemplates = (catalogOtherCostTemplatesIds: number[], onRemoveSuccess: () => void) => {
    const dispatch = useDispatch();

    const [catalogRemoveOtherCostTemplatesReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        catalogRemoveOtherCostTemplatesReset(undefined);

        onRemoveSuccess();
    }, [catalogRemoveOtherCostTemplatesReset, onRemoveSuccess]);

    const [
        catalogRemoveOtherCostTemplatesData,
        catalogRemoveOtherCostTemplatesStatus,
        catalogRemoveOtherCostTemplatesError,
        catalogRemoveWorkRequest,
    ] = useRequest({
        requestId,
        query: removeCatalogUEROtherCostTemplates,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const catalogRemoveOtherCostTemplatesRequest = useCallback(() => {
        dispatch(catalogRemoveWorkRequest({ ids: catalogOtherCostTemplatesIds }));
    }, [catalogRemoveWorkRequest, catalogOtherCostTemplatesIds, dispatch]);

    useEffect(() => {
        catalogRemoveOtherCostTemplatesReset(undefined);
    }, [catalogRemoveOtherCostTemplatesReset]);

    return {
        catalogRemoveOtherCostTemplatesRequest,
        catalogRemoveOtherCostTemplatesData,
        catalogRemoveOtherCostTemplatesStatus,
        catalogRemoveOtherCostTemplatesError,
    };
};
